var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e5922b79-3eb5-425a-83c1-297f8faae433",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.121,16l6.217-6.217c.586-.585.586-1.536,0-2.121-.585-.586-1.536-.586-2.121,0l-6.217,6.217-6.217-6.217c-.585-.586-1.536-.586-2.121,0-.586.585-.586,1.536,0,2.121l6.217,6.217-6.217,6.217c-.586.585-.586,1.536,0,2.121.293.293.677.439,1.061.439s.768-.146,1.061-.439l6.217-6.217,6.217,6.217c.293.293.677.439,1.061.439s.768-.146,1.061-.439c.586-.585.586-1.536,0-2.121l-6.217-6.217Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross1);
export default __webpack_public_path__ + "static/media/Cross_1.a4b7024843133fbe0d56851843be5d28.svg";
export { ForwardRef as ReactComponent };